<template lang="pug">
div.box
    v-server-table(
        :url="api",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
        template(slot="beforeFilter")
            div.m-l-sm.float-right.mode-filter
                select.form-control.c-select(
                    @change="setModeFilter"
                )
                    option(:value="null") Filter modifier mode
                    option(:value="0") Instruction
                    option(:value="1") Topup
                    option(:value="2") Deduct
                    option(:value="3") Discount
</div>
</template>

<style lang="scss">
@media screen and (max-width: 767px) {
    .mode-filter {
        margin-left: 0 !important;
        margin-right: 0;
        margin-bottom: 0.5rem;
        float: none !important;
    }
}
</style>

<script>
export default {
    data: function() {
        var that = this;
        return {
            tableName: 'VUETABLE_MODIFIER',
            columns: ['name', 'mode', 'total_quantity', 'accumulated'],
            options: {
                texts: {
                    title: 'Modifier Sales',
                    description: 'Modifier Sales Report',
                },
                useReportFilter: true,
                initFilters: {
                    mode: null,
                },
                templates: {
                    mode(h, row) {
                        return row.mode_name;
                    },
                },
                customFilters: ['mode'],
                pdf_url: Laroute.route(
                    'franchise.report.modifier.exportAsFile',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.modifier.exportAsFile',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.modifier.exportAsFile',
                    { type: 'XLSX' },
                ),
            },
        };
    },
    computed: {
        api() {
            return Laroute.route('franchise.report.modifier.index');
        },
    },

    methods: {
        setModeFilter(e) {
            const val = e.target.value || null;
            this.$store.commit(`${this.tableName}/SET_CUSTOM_FILTER`, {
                filter: 'mode',
                value: val,
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/modifier/index.vue